import React from 'react';
import { TimePicker } from 'antd';

const CustomTimePicker = ({ value,label, onChange, format = 'HH:mm', ...rest }) => {
  return (
    <div>
      {label && (
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
          {label}
        </label>
      )}
      <TimePicker
        value={value}
        onChange={onChange}
        format={format}
        use12Hours={format !== "HH:mm"}
        {...rest}
    />
    </div>
    
  );
};

export default CustomTimePicker;